import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-group-addon input-group-addon-title"
}
const _hoisted_2 = { class: "input-group-btn input-btn-toggle" }
const _hoisted_3 = { class: "dropdown-menu" }
const _hoisted_4 = {
  key: 0,
  class: "dropdown-header"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { class: "dropdown-header" }
const _hoisted_10 = ["id", "name", "autofocus", "placeholder", "aria-label"]
const _hoisted_11 = {
  key: 1,
  class: "input-group-btn input-btn-toggle"
}
const _hoisted_12 = { class: "input-group-btn" }
const _hoisted_13 = { class: "help-block" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  for: "newFilterName",
  class: "control-label col-sm-2"
}
const _hoisted_16 = { class: "col-sm-10" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "control-label col-sm-2" }
const _hoisted_19 = { class: "col-sm-10" }
const _hoisted_20 = { class: "form-control form-control-static" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "control-label col-sm-2" }
const _hoisted_25 = { class: "col-sm-10" }
const _hoisted_26 = { class: "form-control form-control-static" }
const _hoisted_27 = {
  key: 0,
  class: "form-group"
}
const _hoisted_28 = { class: "control-label col-sm-2" }
const _hoisted_29 = { class: "col-sm-10" }
const _hoisted_30 = { class: "form-control form-control-static" }
const _hoisted_31 = { class: "modal-body" }
const _hoisted_32 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_node_filter_link = _resolveComponent("node-filter-link")!
  const _component_btn = _resolveComponent("btn")!
  const _component_popover = _resolveComponent("popover")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "input-group nodefilters multiple-control-input-group" }, _ctx.$attrs), [
      (_ctx.showTitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("nodes")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-default dropdown-toggle job_edit__node_filter__filter_select_dropdown", {
          'btn-success': _ctx.selectedFilterName,
          'btn-default': !_ctx.selectedFilterName,
        }]),
          "data-toggle": "dropdown",
          "data-testid": "nfi-toggle"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.filterNameDisplay), 1),
          _cache[12] || (_cache[12] = _createTextVNode()),
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "caret" }, null, -1))
        ], 2),
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", null, [
            _createVNode(_component_node_filter_link, {
              "node-filter-name": ".*",
              "node-filter": ".*",
              class: _normalizeClass({
              active: '.*' === _ctx.selectedFilterName,
              job_edit__node_filter__filter_select_all: true,
            }),
              onNodefilterclick: _ctx.handleNodefilter
            }, {
              default: _withCtx(() => [
                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-asterisk" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("show.all.nodes")), 1)
              ]),
              _: 1
            }, 8, ["class", "onNodefilterclick"])
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("li", { class: "divider" }, null, -1)),
          (_ctx.selectedFilterName)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t("filter")) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.filterNameDisplay), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.canSaveFilter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveFilterModal = true))
                }, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "glyphicon glyphicon-plus" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("save.filter.ellipsis")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.canDeleteFilter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteFilterModal = true))
                }, [
                  _cache[16] || (_cache[16] = _createElementVNode("i", { class: "glyphicon glyphicon-remove" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("delete.this.filter")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.canSetDefaultFilter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setDefaultFilter && _ctx.setDefaultFilter(...args)))
                }, [
                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "glyphicon glyphicon-filter" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("set.as.default.filter")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.canRemoveDefaultFilter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeDefaultFilter && _ctx.removeDefaultFilter(...args)))
                }, [
                  _cache[18] || (_cache[18] = _createElementVNode("i", { class: "glyphicon glyphicon-ban-circle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("remove.default.filter")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.nodeSummary && _ctx.nodeSummary.filters && _ctx.nodeSummary.filters.length > 0
          )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _cache[20] || (_cache[20] = _createElementVNode("li", { class: "divider" }, null, -1)),
                _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.$t("saved.filters")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeSummary.filters, (filter) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createVNode(_component_node_filter_link, {
                      "node-filter-name": filter.filterName,
                      "node-filter": filter.filter,
                      onNodefilterclick: _ctx.handleNodefilter
                    }, _createSlots({ _: 2 }, [
                      (_ctx.selectedFilterName === filter.filterName)
                        ? {
                            name: "suffix",
                            fn: _withCtx(() => [
                              _cache[19] || (_cache[19] = _createElementVNode("span", null, [
                                _createElementVNode("i", { class: "fa fa-check" })
                              ], -1))
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["node-filter-name", "node-filter", "onNodefilterclick"])
                  ]))
                }), 256))
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        id: _ctx.filterFieldId,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.outputValue) = $event)),
        type: "search",
        name: _ctx.filterFieldName,
        class: "schedJobNodeFilter form-control",
        autofocus: _ctx.autofocus,
        placeholder: _ctx.queryFieldPlaceholderText || _ctx.$t('enter.a.node.filter'),
        "aria-label": _ctx.queryFieldPlaceholderText || _ctx.$t('enter.a.node.filter'),
        "data-testid": "filter-input",
        onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)), ["prevent"]), ["enter"])),
        onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)))
      }, null, 40, _hoisted_10), [
        [_vModelText, _ctx.outputValue]
      ]),
      (_ctx.helpButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_btn, {
              id: "filterSearchHelpBtn",
              tabindex: "0",
              class: "dropdown-toggle"
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createElementVNode("i", { class: "glyphicon glyphicon-question-sign" }, null, -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_btn, {
          type: `${_ctx.searchBtnType} btn-fill`,
          disabled: !_ctx.outputValue,
          class: "node_filter__dosearch",
          onClick: _ctx.doSearch
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Search")), 1)
          ]),
          _: 1
        }, 8, ["type", "disabled", "onClick"])
      ])
    ], 16),
    (_ctx.helpButton)
      ? (_openBlock(), _createBlock(_component_popover, {
          key: 0,
          target: "#filterSearchHelpBtn",
          trigger: "focus",
          placement: "bottom"
        }, {
          popover: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("select.nodes.by.name")) + ":", 1),
              _createElementVNode("p", null, [
                _createElementVNode("code", null, _toDisplayString(_ctx.$t("mynode1.mynode2")), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("this.will.select.both.nodes")), 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("filter.nodes.by.attribute.value")) + ":", 1),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("include")) + ": ", 1),
                  _createElementVNode("code", null, _toDisplayString(_ctx.$t("attribute")) + ": " + _toDisplayString(_ctx.$t("value")), 1)
                ]),
                _createElementVNode("li", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("exclude")) + ": ", 1),
                  _createElementVNode("code", null, "!" + _toDisplayString(_ctx.$t("attribute")) + ": " + _toDisplayString(_ctx.$t("value")), 1)
                ])
              ]),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("use.regular.expressions")), 1),
              _cache[23] || (_cache[23] = _createElementVNode("p", null, [
                _createElementVNode("code", null, "hostname: dev(\\d+).test.com"),
                _createTextVNode(". ")
              ], -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t("regex.syntax.checking")) + ":", 1),
              _createElementVNode("p", null, [
                _createElementVNode("code", null, _toDisplayString(_ctx.$t("attribute")) + ": /regex/", 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      modelValue: _ctx.saveFilterModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.saveFilterModal) = $event)),
      title: _ctx.$t('save.node.filter')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_btn, {
            "data-testid": "sfm-button-cancel",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveFilterModal = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("button.action.Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_btn, {
            type: "primary",
            "data-testid": "sfm-button-save",
            onClick: _ctx.saveFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("save.filter.ellipsis")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("name.prompt")), 1),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                id: "newFilterName",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newFilterName) = $event)),
                type: "text",
                class: "form-control input-sm",
                "data-testid": "new-filter-name-input"
              }, null, 512), [
                [_vModelText, _ctx.newFilterName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("filter")), 1),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.outputValue), 1)
            ])
          ]),
          (_ctx.saveFilterModalError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.saveFilterModalError), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.deleteFilterModal,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.deleteFilterModal) = $event)),
      title: _ctx.$t('delete.saved.node.filter')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_btn, {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteFilterModal = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("no")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_btn, {
            type: "danger",
            onClick: _ctx.deleteFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("yes")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("name.prompt")), 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.selectedFilterName), 1)
              ])
            ]),
            (_ctx.selectedSavedFilter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("filter")), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.selectedSavedFilter.filter), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("delete.this.filter.confirm")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}